import { Observable } from "./Observable";
import { Graph } from "../graph/Graph";

export default new Observable<Graph>();
